import { useMutation, useQueryClient } from 'react-query';
import OfficeService from '../../../services/office-service';

export const useCreateOffice = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error } = useMutation(
    OfficeService.create,
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(['offices']);
      },
    }
  );
  return { mutate, isLoading, isError, error };
};
